<nav class="navbar">
  <div class="brand">NgKart</div>
  <a class="toggle" (click)="toggle()">
    <span [ngClass]="{ bar: true, active: showLink === true }"></span>
    <span [ngClass]="{ bar: true, active: showLink === true }"></span>
    <span [ngClass]="{ bar: true, active: showLink === true }"></span>
  </a>
  <div [ngClass]="{ 'nav-links': true, active: showLink === true }">
    <ul>
      <li
        [ngClass]="{
          active:
            router.url === '/' ||
            router.url.search('edit') !== -1 ||
            router.url.search('add') !== -1 ||
            router.url.search('delete-prod') !== -1
        }"
        (click)="navigate('/')"
      >
        Home
      </li>
      <ng-container *ngIf="email; else unauth">
        <li
          (click)="navigate('/cart')"
          [ngClass]="{ active: router.url === '/cart' }"
        >
          Cart
        </li>
        <li
          (click)="navigate('/orders')"
          [ngClass]="{ active: router.url === '/orders' }"
        >
          Orders
        </li>
        <li (click)="logout()">Logout</li>
        <li class="user">Signed in as {{ email }}</li>
      </ng-container>
      <ng-template #unauth>
        <li
          [ngClass]="{ active: router.url === '/auth' }"
          (click)="navigate('/auth')"
        >
          Signin
        </li>
      </ng-template>
    </ul>
  </div>
</nav>
